module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1713390618289.4176d0bc. Script 03 2024";